import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Requires Approval Orders list configuration
 * Orders requiring approval (embedded in client view)
 */
export const clientEmbeddedRequiresApprovalOrdersList: ListBuilderList = {
	id: 'client-embedded-requires-approval-orders',
	cacheTTL: 600000,
	name: 'Requires Approval',
	type: 'default',
	active: true,
	sortOrder: 2,
	requiredFeature: 'order-entry',
	columns: createStandardOrderClientEmbeddedColumns(),
	description:
		"Orders requiring approval - filtered for 'Approval Required' status",
	defaultSortId: 'column-dates-asc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderStatus: {
			defaultValue: [
				{
					id: '8',
					data: {
						id: '8',
						label: 'Approval Required',
					},
					label: 'Approval Required',
				},
			],
		},
	},
};
